import { useEffect, useState } from "react";
import { useTheme } from "../../components/ThemeProvider";
export const useBelowBreakpoint = (size) => {
    const [matches, setMatches] = useState(false);
    const { breakpoints } = useTheme();
    // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
    useEffect(() => {
        const query = `(max-width: ${breakpoints[size] ?? 0}px)`;
        if (typeof window === "undefined") {
            return;
        }
        const mediaQuery = window.matchMedia(query);
        setMatches(mediaQuery.matches);
        const handler = (event) => setMatches(event.matches);
        mediaQuery.addEventListener("change", handler);
        return () => mediaQuery.removeEventListener("change", handler);
    }, []);
    return matches;
};
//# sourceMappingURL=media-query.js.map